import { connect } from 'react-redux';
import {
    resourceGetAll
} from '../service';
import BaseSelectBox from '../../../../base/components/BaseSelectBox';

class ResourceSelectBox extends BaseSelectBox {

}

const mapStateToProps = (state) => {
    return {
        languages: state.appSettings.data.languages,
        listData: state.coreResources.suggestion
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getAllData: () => {
            return dispatch(resourceGetAll());
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ResourceSelectBox);
